import { createContext, useContext } from "react";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface DialogContextProps {}

export const DialogContext = createContext<DialogContextProps | null>(null);

export const useDialogContext = () => {
  const context = useContext(DialogContext);

  if (!context) {
    throw new Error(
      "Child components of Dialog can not be rendered outside the Dialog component!"
    );
  }

  return context;
};
